import React, { useState } from "react";
import detectEthereumProvider from "@metamask/detect-provider";
import { ethers } from "ethers";

const WalletConnect = ({ setProvider, setAccount }) => {
    const [address, setAddress] = useState("");

    const connectWallet = async () => {
        const provider = await detectEthereumProvider();
        if (!provider) {
            alert("MetaMask가 설치되어 있지 않습니다.");
            return;
        }

        await provider.request({ method: "eth_requestAccounts" });
        const ethersProvider = new ethers.BrowserProvider(window.ethereum);
        const signer = await ethersProvider.getSigner();
        const userAddress = await signer.getAddress();

        setAddress(userAddress);
        setProvider(ethersProvider);
        setAccount(userAddress);
    };

    return (
        <div>
            <button onClick={connectWallet}>지갑 연결</button>
            <div>주소: {address}</div>
        </div>
    );
};

export default WalletConnect;
